import { omit } from 'lodash';
import { TaboolaGraph, SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import { BID_STRATEGIES } from '../../../../common-campaign-form';
import * as FIELDS from '../../fields';
import {
    dayWeekMonthGetXAxisFormatter,
    dayWeekMonthXAxisMinTickGap,
    tooltipDateFormatter,
} from '../../fields/transformers';
import metrics from '../../metrics';

const { AXIS_SCALE, AXIS_TYPE, AXIS_DOMAIN } = TaboolaGraph;

const graph = {
    type: GRAPHS.LINE,
    endpoint: 'campaign-report-by-day-performance',
    metrics: [
        metrics.SPENT,
        metrics.VISIBLE_IMPRESSIONS,
        metrics.IMPRESSIONS,
        metrics.CLICKS,
        metrics.VCTR,
        metrics.CTR,
        metrics.AVERAGE_CPC,
        metrics.CVR,
        metrics.CVR_CLICKS,
        metrics.CVR_VIEWS,
        metrics.CONVERSIONS,
        metrics.CONVERSIONS_CLICKS,
        metrics.CONVERSIONS_VIEWS,
        metrics.CPA,
        metrics.CPA_CLICKS,
        metrics.CPA_VIEWS,
        metrics.VCPM,
        metrics.CPM,
        metrics.CONVERSIONS_VALUE,
        metrics.ROAS,
        metrics.ROAS_CLICKS,
        metrics.ROAS_VIEWS,
    ],
    defaultSort: [{ field: 'date', order: SORTING_ORDER_TYPES.ASCENDANT }],
    graphProps: {
        xAxisDataKey: FIELDS.DATE.field,
        xAxisMinTickGap: dayWeekMonthXAxisMinTickGap,
        getXAxisFormatter: dayWeekMonthGetXAxisFormatter,
        toolTipLabelFormatter: tooltipDateFormatter,
        xAxisScale: AXIS_SCALE.LINEAR,
        xAxisType: AXIS_TYPE.NUMBER,
        xAxisDomain: [AXIS_DOMAIN.DATA_MIN, AXIS_DOMAIN.DATA_MAX],
    },
    metricsViewTransformer: ({ entity: { bidStrategy }, graphMetrics }) => ({
        graphMetrics: graphMetrics.map(graphMetric => {
            if (graphMetric.name === 'cpa' && bidStrategy !== BID_STRATEGIES.TARGET_CPA) {
                return omit(graphMetric, 'referenceLines');
            }
            return graphMetric;
        }),
    }),
};

export default graph;
